"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import { MattersCard } from "./MattersCard";

export function MattersCardsGrid({ mattersCardWrapperSlot = "" }) {
  return (
    <Block className={"matters_card-wrapper"} tag={"div"}>
      {mattersCardWrapperSlot ?? (
        <>
          <MattersCard
            iconImage={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b197ada7d32e45dd83176_heart.svg"
            }
          />
          <MattersCard
            iconImage={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b190a79e90671086314d4_Layer_2.svg"
            }
            text={"Your Home Matters"}
          />
          <MattersCard
            iconImage={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b191b78f7fd35ce1bda0a_Layer_2-1.svg"
            }
            text={"Built On Trust"}
          />
          <MattersCard
            iconImage={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b192ab73350a82af6808e_Layer_1.svg"
            }
            text={"Lease With Confidence"}
          />
          <MattersCard
            iconImage={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b193d387e970e54128cca_Layer_2-2.svg"
            }
            text={"Actions Speak Louder"}
          />
          <MattersCard
            iconImage={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b19511563f1bffd7d5881_Layer_2-3.svg"
            }
            text={"We Are A Community"}
          />
        </>
      )}
    </Block>
  );
}
